import * as yup from 'yup';

const OrgRefSchema = yup
  .object({
    id: yup.number().defined(),
    name: yup.string().defined(),
  })
  .defined();

export const UserSearchResultSchema = yup.object({
  id: yup.number().defined(),
  email: yup.string().defined(),
  name: yup.string().nullable().default(null),
  last_login_at: yup.string().nullable().default(null),
  parent_org: OrgRefSchema.nullable().default(null),
  orgs: yup.array(OrgRefSchema).nullable().default(null),
});

export const UserSearchResponseSchema = yup.object({
  users: yup.array(UserSearchResultSchema.defined()).defined(),
});

const OffboardedOrgSchema = yup
  .object({
    id: yup.number().defined(),
    name: yup.string().defined(),
  })
  .defined();

export const UserOffboardResponseSchema = yup.object({
  user_id: yup.number().defined(),
  orgs_removed: yup.array(OffboardedOrgSchema).defined(),
});

export type OrgRef = yup.InferType<typeof OrgRefSchema>;
export type UserSearchResult = yup.InferType<typeof UserSearchResultSchema>;
export type UserSearchResponse = yup.InferType<typeof UserSearchResponseSchema>;
export type UserOffboardResponse = yup.InferType<
  typeof UserOffboardResponseSchema
>;
